module.exports = __webpack_public_path__ + "static/media/hot_zgyxh.7b67513c.png";